import { userHasRole } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    return false;
  },
};
